import React from "react";
import * as Mui from "@mui/material";
import * as env from "shared/env";

interface Props {
	open: boolean;
	onCancel: () => void;
	onConfirm: () => void;
}

export const StopImportConfirmDialog: React.FC<Props> = ({ open, onCancel, onConfirm }) => {
	return (
		<Mui.Dialog open={open} onClose={onCancel}>
			<Mui.DialogTitle>Cancel bulk upload?</Mui.DialogTitle>
			<Mui.DialogContent>
				<Mui.DialogContentText>
					Uploads are processed in groups. Entries that have already been processed will
					remain uploaded.
					<br />
					Canceling now will discard any remaining entries that haven't been processed yet.
				</Mui.DialogContentText>
			</Mui.DialogContent>
			<Mui.DialogActions>
				<Mui.Button onClick={onCancel} color="primary" variant="outlined">
					Continue Upload
				</Mui.Button>
				<Mui.Button onClick={onConfirm} color={"primary"} variant="contained">
					Cancel Upload
				</Mui.Button>
			</Mui.DialogActions>
		</Mui.Dialog>
	);
};
